<template>
  <el-dialog v-dialogDrag :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="renameDialogVisible" title="重命名" width="27%" top="25vh">
    <div>
      <el-form ref="renameForm" :model="renameForm" label-position="top" label-width="110px" :rules="renameFormRules" size="small">
        <p style="color:#F56C6C;font-size:16px;text-indent: 2em;">原存放位置中已包含名为 "{{ name }}" 的{{ typeTitle }}, 您可对{{ typeTitle }}进行重命名操作后再进行恢复操作</p>
        <el-form-item label="名称:" prop="name">
          <el-input ref="name" v-model.trim="renameForm.name" placeholder="请输入名称" size="small" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="renameDialogVisible = false">取 消</el-button>
      <el-button type="primary" size="small" @click="renameDetermine">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import docService from "@/CommonDP/service/doc-service";
export default {
  props: {},
  data() {
    var nameV = (rule, value, callback) => {
      const regExp = new RegExp('[\\\\|/:*<>?"]');
      let typeTitle = "";
      this.renameForm.isFolder === 0 ? (typeTitle = "文件") : (typeTitle = "文件夹");
      if (value === "") {
        callback(new Error(typeTitle + "名称不能为空"));
      } else if (value.length > 80) {
        callback(new Error(typeTitle + "名称不能大于80个字符"));
      } else if (regExp.test(value)) {
        callback(new Error(typeTitle + '名称不能包含以下字符:\\ / : * " ? < > |'));
      } else {
        this.repeat = callback;
        this.checkNameExist();
      }
    };
    return {
      renameDialogVisible: false,
      renameFormRules: {
        name: [{ required: true, trigger: "blur", validator: nameV }]
      },
      renameForm: { name: '' },
      typeTitle: '',
      name: '',
      suffix: "",
      repeat: ""
    };
  },
  methods: {
    show(data) {
      this.name = data.name;
      this.renameDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.name.focus();
        this.$refs.renameForm.clearValidate();
      });
      this.typeTitle = data.isFolder === 0 ? "文件" : "文件夹";
      if (data.isFolder === 0) {
        this.suffix = data.name.split(".");
        const typeIndex = data.name.lastIndexOf(".");
        const newName = data.name.substring(0, typeIndex);
        this.renameForm = { ... data };
        this.renameForm.name = newName;
      } else {
        this.renameForm = data;
      }
    },
    async renameDetermine() {
      this.$refs.renameForm.validate(async (valid) => {
        if (valid) {
          const name = this.renameForm.name.replace(/\s*/g, "");
          if (this.renameForm.isFolder === 0) {
            this.renameForm.name = `${name}.${this.suffix[this.suffix.length - 1]}`;
          } else {
            this.renameForm.name = name;
          }
          await docService.recycleRenameRestore(this.renameForm);
          this.renameDialogVisible = false;
          this.$emit("callback");
        } else {
          return false;
        }
      });
    },
    async checkNameExist() {
      let name = this.renameForm.name.replace(/\s*/g, "");
      if (this.renameForm.isFolder === 0) {
        name = `${name}.${this.suffix[this.suffix.length - 1]}`;
      }
      const params = {
        ...this.renameForm,
        name
      };
      const { data } = await docService.docCheckNameExist(params);
      if (data) {
        const typeTitle = this.renameForm.isFolder === 0 ? "文件" : "文件夹";
        this.repeat(new Error("原存放位置已包含同名" + typeTitle));
      } else {
        this.repeat();
      }
    }
  }
};
</script>

<style>
</style>
